export enum JWTUserAuthenticator {
  CUSTOMER = "customer",
  AUTH0 = "auth0",
}
